$(document).ready(function () {
  $('.testimonial-slider').slick({
        dots: false,
        infinite: true,
         arrows: true,
        speed: 500,
    adaptiveHeight: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });
  $('#instafeed_slider').slick({
        dots: false,
        infinite: true,
         arrows: true,
        speed: 500,
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 1,
    responsive: [
       {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
               infinite: true,
             
                slidesToScroll: 1
            }
        }]
    });

  /*
$('.multicolumn-list').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        fade: false,
       centerMode: false,
                centerPadding: '0px',
        slidesToShow: 4,
        slidesToScroll: 4,
     responsive: [
       {
            breakpoint: 767,
            settings: {
               dots: true,
              infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }]
    });
*/
  
});